import React from "react";
import { compose } from "recompose";
import { DocumentRenderer } from "components";
import { Trans } from "react-i18next";
import withData from "./withData";
import { Table } from "reactstrap";
import { formatCurrency, convertUTCToLocal, CurrencySymbol } from "services/util";
import { withSelectedOrganisation } from "../../components/withSelectedOrganisation";
import MainHeader from "./MainHeader";
import HeaderData from "./HeaderData";

const TH = ({ children, ...props }) => (
  <th {...props}>
    <Trans>{children}</Trans>
  </th>
);

export const RemittanceDocument = ({
  item,
  contact,
  organisation,
  taxRates,
  settings,
  t,
  ...props
}) => (
  <DocumentRenderer {...props}>
    <div className="container-fluid m-0 p-0">
      <MainHeader item={item} company={organisation} client={contact} taxRates={taxRates} t={t} settings={settings} doc_name={'Remittance Advice'} logo={props.selectedOrganisation.logo} >
        <HeaderData className="mb-1" label={`Payment Date`} value={item.DateString} />
        <HeaderData className="mb-1" label={`Time`} value={convertUTCToLocal(item.UpdatedDateUTC)} />
        <HeaderData className="mb-1" label="Reference" value={item.Reference || item.InvoiceNumber} />
      </MainHeader>

      <Table size="sm" className="table-borderless mt-3" responsive>
        <thead>
          <tr className="border-bottom border-dark">
            <TH>Invoice Date</TH>
            <TH>Reference</TH>
            <TH>Payment Reference</TH>
            <TH className="text-right">Invoice Total</TH>
            <TH className="text-right">Amount Paid</TH>
            <TH className="text-right">Still Owing</TH>
          </tr>
        </thead>
        <tbody>
          <tr className="border-bottom">
            <td>{item.Invoice.DateString}</td>
            <td>{item.Invoice.InvoiceNumber}</td>
            <td>
              <Trans>Payment</Trans>
            </td>
            <td className="text-right">{formatCurrency(item.Invoice.Total)}</td>
            <td className="text-right">{formatCurrency(item.Amount)}</td>
            <td className="text-right">
              {formatCurrency(item.Invoice.AmountDue)}
            </td>
          </tr>
          <tr className="font-weight-bold">
            <td colSpan="3" />
            <td className="border-bottom border-dark text-right">
              <Trans>Total</Trans> <CurrencySymbol currency={item.Invoice.CurrencyCode}/>
            </td>
            <td className="border-bottom border-dark text-right">
              {formatCurrency(item.Amount)}
            </td>
            <td className="border-bottom border-dark text-right">
              {formatCurrency(item.Invoice.AmountDue)}
            </td>
          </tr>
        </tbody>
      </Table>
    </div>
  </DocumentRenderer>
);

const enhance = compose(withData, withSelectedOrganisation());

export default enhance(RemittanceDocument);
